module.exports = __webpack_public_path__ + "static/media/pagination-last.251f802f.svg";